














import { defineComponent, useRoute, computed, onErrorCaptured, ref, useRouter } from '@nuxtjs/composition-api'
import axios from 'axios'
import Stepper from '@/components/feature/checkout-quote/Stepper.vue'
import Breadcrumbs from '~/components/global/navigation/Breadcrumbs.vue'
import { StepperStepInterface } from '~/types/dom/domTypes'
import { Errors } from '~/composables/errors/useErrors'
import { isApiError } from '~/common/utils/errorParsing'
import { usePanelBuilder } from '~/composables/signalstar/usePanelBuilder'

const allSteps: StepperStepInterface[] = [
  {
    step: 1,
    title: 'Target Species',
    path: '/products/signalstar/targetspecies',
  },
  {
    step: 2,
    title: 'Select Your Antibodies',
    path: '/products/signalstar/selectantibodies',
  },
  {
    step: 3,
    title: 'Panel Design',
    path: '/products/signalstar/paneldesign',
  },
  {
    step: 4,
    title: 'Confirmation',
    path: '/products/signalstar/confirmation',
  },
]

export default defineComponent({
  components: { Stepper, Breadcrumbs },
  setup() {
    const QUOTE_REQUEST_PATH = '/products/signalstar/quote-request'

    const route = useRoute()
    const router = useRouter()

    const { resetConfiguration } = usePanelBuilder()

    const showStepper = computed(() => route.value.path !== QUOTE_REQUEST_PATH)
    const disablePrevSteps = computed(() => route.value.path === allSteps[3].path)

    const heading = computed(() =>
      route.value.path === QUOTE_REQUEST_PATH
        ? 'SignalStar™ Multiplex IHC Quote Request'
        : 'SignalStar™ Multiplex IHC Kits & Reagents Panel Builder'
    )

    const errors = ref<Errors>([])

    onErrorCaptured((e: unknown) => {
      if (!axios.isAxiosError(e) && !isApiError(e)) {
        return true
      }

      console.error('Exception caught during panel builder flow.', e)
      errors.value = [
        {
          code: '',
          message:
            'We were not able to complete your SignalStar experiment at this time. Please try again or reach out to our <strong><a href="/learn-and-support/order-support#tech-support">Support</a></strong> team for assistance.',
        },
      ]
      resetConfiguration()

      if (route.value.path !== '/products/signalstar/targetspecies') {
        // This condition is required to avoid `NavigationDuplicated` exceptions
        router.replace('/products/signalstar/targetspecies')
      }
      return false
    })

    return {
      name: 'SignalStar Multiplex IHC Kits & Reagents',
      steps: allSteps,
      heading,
      showStepper,
      disablePrevSteps,
      errors,
    }
  },
})
